/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_OkInputs */

const en_mk_tut_ws_ok = /** @type {(inputs: Mk_Tut_Ws_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The main screen appears with a left menu: Inbox, Approvals, My issues, then your divisions.`)
};

const id_mk_tut_ws_ok = /** @type {(inputs: Mk_Tut_Ws_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampil layar utama dengan menu kiri: Inbox, Approval, Issue saya, lalu daftar divisi Anda.`)
};

/**
* | output |
* | --- |
* | "The main screen appears with a left menu: Inbox, Approvals, My issues, then your divisions." |
*
* @param {Mk_Tut_Ws_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_ok = /** @type {((inputs?: Mk_Tut_Ws_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_ok(inputs)
	return en_mk_tut_ws_ok(inputs)
});